import createReactComponent from '../createReactComponent';
export default createReactComponent('minus', 'Minus', [["path",{"d":"M6 12h12","key":"svg-0"}]]);